import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {ProducerModelQueryParamsNew, SetImageModel} from "../../data/model/Producer";
import {removeItemAtIndex} from "../../utils/Utils";

export interface UploadImageModel {
    tag: string | number;
    imageFile: File;
    // imageFile: string;
}

export interface LandingState {
    currentPage: number;
    producer?: ProducerModelQueryParamsNew;
    isSignup?: boolean;
    isLeftToRight?: boolean;
    images: SetImageModel[];
}

const initialState: LandingState = {
    currentPage: 0,
    producer: undefined,
    isSignup: false,
    isLeftToRight: true,
    images: [],
}

export const landingSlice = createSlice({
    name: "landing",
    initialState,
    reducers: {
        changePage: (state, action: PayloadAction<number>) => {
            state.currentPage = action.payload;
        },
        setFieldModel: (state, action: PayloadAction<ProducerModelQueryParamsNew>) => {
            state.producer = {...state.producer, ...action.payload}
        },
        setIsSignup: (state, action: PayloadAction<boolean>) => {
            state.isSignup = action.payload
        },
        setIsLeftToRight: (state, action: PayloadAction<boolean>) => {
            state.isLeftToRight = action.payload
        },
        addImage: (state, action: PayloadAction<SetImageModel>) => {
            state.images = [...state.images, action.payload];
        },
        removeImage: (state, action: PayloadAction<number>) => {
            // const fileIndex = state.images.indexOf(action.payload);
            state.images = removeItemAtIndex(state.images, action.payload);
            // state.images = state.images.filter((model, index) => model. !== action.payload.tag);
        }
    }
});

export const {
    changePage,
    setFieldModel,
    setIsSignup,
    setIsLeftToRight,
    addImage,
    removeImage,
} = landingSlice.actions;

export default landingSlice.reducer;
